import createSvgIcon from '@mui/material/utils/createSvgIcon';
import { FC } from 'react';

export const LoadingCircleIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    width="200"
    height="200"
  >
    <g>
      <circle cx="50" cy="50" fill="none" strokeWidth="5" r="30" strokeDasharray="141.37166941154067 49.12388980384689">
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        />
      </circle>
      <g />
    </g>
  </svg>,
  'LoadingCircle',
);

export const LoadingCircleSVG: FC<{ size?: number }> = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      width={size || '200'}
      height={size || '200'}
    >
      <g>
        <circle
          cx="50"
          cy="50"
          stroke="currentColor"
          fill="none"
          strokeWidth="5"
          r="30"
          strokeDasharray="141.37166941154067 49.12388980384689"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="1s"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
          />
        </circle>
        <g />
      </g>
    </svg>
  );
};
